import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TICKET_TABS, type TicketTab } from '@/features/admin/shared/tabs';
import { TicketDetailPage } from '@/features/admin/tickets/tickets-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Détail d'un ticket (porting README #92). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/support/$ticketId')({
  validateSearch: (search: Record<string, unknown>): { tab: TicketTab } => ({
    tab: TICKET_TABS.parse(search['tab']),
  }),
  component: TicketRoute,
});

function TicketRoute() {
  const { tenant, ticketId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="tickets"
      crumbs={[
        { label: t('nav.items.tickets') },
        { label: <EntityName tenantId={tenant} kind="ticket" id={ticketId} /> },
      ]}
    >
      <TicketDetailPage
        tenantId={tenant}
        ticketId={ticketId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
